import { Component, computed, input } from '@angular/core';

import { IconButtonComponent } from '../icon-button/icon-button.component';
import { IconComponent } from '../icon/icon.component';
import { OverlayComponent } from '../overlay/overlay.component';
import { OverlayToggleDirective, type OverlaySize } from '../overlay/overlay-toggle.directive';
import type {
  InputSignal,
  Signal,
  TemplateRef
} from '@angular/core';

@Component({
  selector: 'td-wb-tooltip-button',
  imports: [
    IconButtonComponent,
    IconComponent,
    OverlayComponent,
    OverlayToggleDirective
  ],
  templateUrl: './tooltip-button.component.html',
  styleUrls: ['./tooltip-button.component.scss']
})
export class TooltipButtonComponent {
  readonly tooltipText: InputSignal<string> = input<string>('');
  readonly tooltipPosition: InputSignal<string | Array<string> | undefined> = input<string | Array<string> | undefined>(undefined);
  readonly tooltipSize: InputSignal<OverlaySize> = input<OverlaySize>('small');
  readonly iconId: InputSignal<string> = input<string>('tooltip--small');
  readonly iconSize: InputSignal<string> = input<string>('16');
  readonly ariaLabel: InputSignal<string | undefined> = input<string | undefined>(undefined);
  readonly ariaDescribedBy: InputSignal<string | undefined> = input<string | undefined>(undefined, { alias: 'aria-describedby' });

  readonly externalOverlayTemplate: InputSignal<TemplateRef<unknown> | undefined> = input<TemplateRef<unknown> | undefined>(undefined, { alias: 'tdWbOverlayToggle' });

  protected readonly resolvedAriaLabel: Signal<string> = computed((): string => {
    return this.ariaLabel() ?? this.tooltipText();
  });
}

